import animation from './Animation.module.css';

type SkeletonCircleProps = {
    size?: string;
};

export const SkeletonCircle = ({ size = '64px' }: SkeletonCircleProps) => {
    return (
        <div
            // eslint-disable-next-line react/forbid-dom-props
            style={{ width: size, height: size, borderRadius: '50px' }}
            className={animation.skeleton}
        />
    );
};
